import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { primary, neutral } from '../../../../style/colors';
import {
  UserSection,
  UserButton,
  Dropdown,
  DropdownHeader,
  DropdownInfo,
  DropdownItem,
} from './UserDropdown.style';

const UserDropdown = ({
  displayName,
  departmentName,
  email,
  isAdmin,
  adminItems,
  onAdminNavigate,
  onChangeDepartment,
  onLogout,
}) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    if (!isOpen) return;

    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isOpen]);

  const handleAdminNav = (path) => {
    onAdminNavigate(path);
    setIsOpen(false);
  };

  const handleChangeDepartment = () => {
    onChangeDepartment();
    setIsOpen(false);
  };

  const handleLogout = () => {
    setIsOpen(false);
    onLogout?.();
  };

  return (
    <UserSection ref={dropdownRef}>
      <UserButton onClick={() => setIsOpen(!isOpen)}>
        <i className="mdi mdi-account-circle" />
        <span>{displayName}</span>
        <i className={`mdi mdi-chevron-${isOpen ? 'up' : 'down'}`} />
      </UserButton>

      <Dropdown $isOpen={isOpen}>
        <DropdownHeader>
          <i className="mdi mdi-domain" />
          {departmentName || t('department')}
        </DropdownHeader>
        {email && (
          <DropdownInfo>
            <i className="mdi mdi-email-outline" />
            {email}
          </DropdownInfo>
        )}
        {isAdmin && (
          <>
            {adminItems.map((item) => (
              <DropdownItem key={item.path} onClick={() => handleAdminNav(item.path)}>
                <i className={`mdi ${item.icon}`} />
                {item.label}
              </DropdownItem>
            ))}
            <DropdownItem onClick={handleChangeDepartment}>
              <i className="mdi mdi-swap-horizontal" />
              {t('changeDepartment')}
            </DropdownItem>
          </>
        )}
        <DropdownItem
          onClick={handleLogout}
          style={{ borderTop: `1px solid ${neutral[200]}`, marginTop: '4px', color: primary[500] }}
        >
          <i className="mdi mdi-logout" style={{ color: primary[500] }} />
          {t('logout')}
        </DropdownItem>
      </Dropdown>
    </UserSection>
  );
};

UserDropdown.propTypes = {
  displayName: PropTypes.string.isRequired,
  departmentName: PropTypes.string,
  email: PropTypes.string,
  isAdmin: PropTypes.bool,
  adminItems: PropTypes.arrayOf(
    PropTypes.shape({
      path: PropTypes.string.isRequired,
      icon: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
  onAdminNavigate: PropTypes.func.isRequired,
  onChangeDepartment: PropTypes.func.isRequired,
  onLogout: PropTypes.func,
};

export default UserDropdown;
